import BodyText from 'LuxKit/Typography/BodyText'
import * as React from 'react'
import { useIntl } from 'react-intl'

const formatBold = (chunks: React.ReactNode) => <b>{chunks}</b>

interface Props {
  start: string
  end: string
}

function SearchTileRowOverlineJourney({ start, end }: Props) {
  const intl = useIntl()
  const roundTrip = start === end

  const journeyMessage = roundTrip
    ? intl.formatMessage(
        {
          id: 'z0dNwNVtLP7j1R1asc2D',
          defaultMessage: 'Starts and ends in <b>{start}</b>',
        },
        { start, b: formatBold },
      )
    : intl.formatMessage(
        {
          id: 'eEoihG35O_UjUreNx8tE',
          defaultMessage: 'Starts in <b>{start}</b>, ends in <b>{end}</b>',
        },
        { start, end, b: formatBold },
      )

  return <BodyText variant="small" colour="light-foreground-alt">
    {journeyMessage}
  </BodyText>
}

export default SearchTileRowOverlineJourney
